import * as React from "react";
function SvgComponent(props) {
  return <svg {...props} width={33} height={50} fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M.398 49.862C14.884 35.843 22.288 10.84 9.71.136l22.869 19.46C30.395 35.084 16.669 42.146.398 49.862z" fill="#FFFBFB" /></svg>;
}
export default SvgComponent;